import style from './style.module.css';
import { Eye, Tickets, User, MoneyWhite } from '~/svgs/business';
import { Translate, useTranslate } from '~/i18n';

const Community = () => {
   const { translate } = useTranslate();

   const wins = [
      {
         number: '1.5',
         svg: <User className="p-1 lg:p-0" />,
         title: translate({ id: 'business:customers' }),
      },
      {
         number: '300',
         svg: <MoneyWhite className="p-1 lg:p-0" />,
         title: translate({ id: 'business:sales value' }),
      },
      {
         number: '10',
         svg: <Eye className="p-1 lg:p-0" />,
         title: translate({ id: 'business:costumer reach' }),
      },
      {
         number: '3.1',
         svg: <Tickets className="p-1 lg:p-0" />,
         title: translate({ id: 'business:tickets sold' }),
      },
   ];
   return (
      <div id="our-community" className={`${style['yellow-bg']}`}>
         <div className=" font-bold md:pt-[109px] md:pb-[129px] py-10 text-white text-[30px] lg:text-[60px] ">
            <Translate id="business:how hy keeps winning" />
         </div>
         <div className="grid md:grid-cols-4 justify-items-center text-white pb-10 md:pb-[111px] space-y-10 md:space-y-0 md:space-x-10">
            {wins.map((value, key) => (
               <div key={key} className="grid justify-items-center">
                  <div className="flex">
                     <div className="text-6xl md:text-[100px] font-bold flex italic">
                        {value.number}
                     </div>
                     <div className="ltr:text-3xl md:ltr:text-[50px] rtl:text-2xl md:rtl:text-[40px] pt-5 md:pt-14 px-2 font-medium">
                        <Translate id="business:million" />
                     </div>
                  </div>
                  <div className="flex pb-[12px] pt-2 ">
                     <div className="lg:pt-0.5">{value.svg}</div>
                     <div className="px-1.5 md:px-4 text-[13px] md:text-2xl pt-1 lg:pt-0 ">
                        {value.title}
                     </div>
                  </div>
                  <div className="font-bold">
                     <hr className="w-[66px] md:w-[120px]" />
                  </div>
               </div>
            ))}
         </div>
      </div>
   );
};
export default Community;
